import List from "@/components/treeList";
import Bus from "./Bus.js";

const Table = args => {
  // 编辑
  function handleUpdate({ uuid }) {
    Bus.$emit("updateCr", uuid);
  }

  //删除
  function handleDelete({ uuid }) {
    Bus.$emit("deleteCr", uuid);
  }

  //启用
  function handleDisplay(status, uuid, msg) {
    Bus.$emit("displayCr", status, uuid, msg);
  }

  const Deal = ({ props: { vo } }) => {
    const cr = vo.row;
    const dealConf = [
      ["编辑", () => handleUpdate(cr), "icon-edit", "creditRule:update"],
      ["删除", () => handleDelete(cr), "icon-delete", "creditRule:delete"]
    ];
    if (cr.ruleStatus === 1) {
      dealConf.push([
        "启用",
        () => handleDisplay(0, cr.uuid, "启用"),
        "icon-enable",
        "creditRule:display"
      ]);
    } else {
      dealConf.push([
        "停用",
        () => handleDisplay(1, cr.uuid, "停用"),
        "icon-unable",
        "creditRule:display"
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[0]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[2]} onClick={item[1]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "类型名称",
      prop: "resourceTypeName",
      minWidth: "120"
    },
    {
      label: "所属组织",
      prop: "deptName",
      minWidth: "120"
    },
    {
      label: "时长",
      prop: "duration",
      minWidth: "80"
    },
    {
      label: "计量单位",
      prop: "unitName",
      minWidth: "80"
    },
    {
      label: "学时",
      prop: "credit",
      width: "150"
    },
    {
      label: "状态",
      prop: "ruleStatusName",
      width: "130"
    },
    {
      label: "操作",
      width: "150",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};
export default Table;
